import { CommonModule } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { CookieService } from 'ngx-cookie-service';
import { AppComponent } from './app.component';
import { AppRoutes } from './app.routes';
import { ContentfulModule } from '~contentful/contentful.module';
import { OAuthModule } from 'angular-oauth2-oidc';
import * as COMPONENTS from './components';
import * as DIRECTIVES from './directives';
import * as SERVICES from './services';
import * as VIEWS from './views';
import * as SHAREDDATA from 'src/app/shared-data';
import { environment } from 'src/environments/environment';
import { MaterialModule } from './material.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';

@NgModule({
  declarations: [
    AppComponent,
    VIEWS.HomeViewFeatureSwitchComponent,
    VIEWS.HomeViewComponent,
    VIEWS.HomeViewV2Component,
    VIEWS.CheckoutViewFeatureSwitchComponent,
    VIEWS.CheckoutViewComponent,
    VIEWS.CheckoutViewV2Component,
    VIEWS.CreateCheckoutViewComponent,
    VIEWS.CompleteViewFeatureSwitchComponent,
    VIEWS.CompleteViewComponent,
    VIEWS.CompleteViewV2Component,
    VIEWS.ErrorViewComponent,
    VIEWS.ErrorUnavailableViewComponent,
    VIEWS.PendingComponent,
    VIEWS.AuthLoginViewComponent,
    VIEWS.AuthCallbackViewComponent,
    VIEWS.MobileSSOViewComponent,
    VIEWS.MobileSSOStartViewComponent,
    VIEWS.NativeCheckoutCallbackViewComponent,
    COMPONENTS.GiftCardComponent,
    COMPONENTS.GiftCardListComponent,
    COMPONENTS.HeaderComponent,
    COMPONENTS.SectionContentComponent,
    COMPONENTS.FooterComponent,
    COMPONENTS.MobileFooterComponent,
    COMPONENTS.LoaderComponent,
    COMPONENTS.LoaderInnerComponent,
    COMPONENTS.NewDesignVariantComponent,
    COMPONENTS.NewDesignVariantV2Component,
    COMPONENTS.SelectOptionComponent,
    COMPONENTS.SelectOptionV2Component,
    COMPONENTS.SpinnerComponent,
    COMPONENTS.BuyForFriendComponent,
    COMPONENTS.BuyForFriendV2Component,
    COMPONENTS.GiphyComponent,
    COMPONENTS.GiftCardCategoryComponent,
    COMPONENTS.GiftCardCategoryV2Component,
    COMPONENTS.CountrySwitcherComponent,
    COMPONENTS.SlideMenuComponent,
    COMPONENTS.DatePickerComponent,
    COMPONENTS.FooterMenuComponent,
    COMPONENTS.FooterItemComponent,
    COMPONENTS.HeaderMenuComponent,
    COMPONENTS.HeaderItemComponent,
    COMPONENTS.StepHeaderComponent,
    COMPONENTS.StepHeaderStepComponent,
    DIRECTIVES.RouterBackDirective,
    DIRECTIVES.OnlyNumber,
  ],
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    AppRoutes,
    HttpClientModule,
    ContentfulModule,
    MaterialModule,
    FlexLayoutModule,
    OAuthModule.forRoot(),
  ],
  providers: [
    SERVICES.GiftCardsService,
    SERVICES.GiftCardsV2Service,
    SERVICES.ShopCentralService,
    SERVICES.CheckoutService,
    SERVICES.CheckoutV2Service,
    SERVICES.LoaderService,
    CookieService,
    SHAREDDATA.SelectOptionService,
    SHAREDDATA.SelectOptionV2Service,
    SHAREDDATA.GiftcardCategoryV2Service,
    SHAREDDATA.GiftcardCategoryService,
    SHAREDDATA.GiftcardCategoryV2Service,
    SHAREDDATA.CheckoutStateService,
    SERVICES.ValidationService,
    SERVICES.GiphyService,
    SERVICES.AuthService,
    SERVICES.Auth0Service,
    SERVICES.IDS4Service,
    SERVICES.AuthGuardService,
    SERVICES.ThanksScriptService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SERVICES.AuthInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SERVICES.UnauthorizedErrorInterceptor,
      multi: true,
    },
    SERVICES.TrxService,
    SERVICES.MarkdownService,
    SERVICES.MobileSSOService,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
